import { useState } from 'react';
import * as Base from '@base';
import { useTranslation } from '@common';
import { Rule, Confirm, Uploader, Result } from './steps';
import { Footer } from './footer';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { ImporterProps, RowValue } from './types';

export function Importer(props: ImporterProps): ReactElement {
  const [t] = useTranslation();
  const [step, setStep] = useState(0);
  const [data, setData] = useState<RowValue[]>([]);

  const steps = [
    { title: t('导入规则') },
    { title: t('上传文件') },
    { title: t('数据确认') },
    { title: t('导入结果') }
  ];

  const onCloseModal = (): void => {
    setStep(0);
    setData([]);
    props.onClose();
  };

  const onConfirmModal = (): void => {
    props.onConfirm(data);
    setStep(step + 1);
  };

  return (
    <Base.Modal
      destroyOnClose
      title={props.title}
      centered
      open={props.open}
      width={800}
      onCancel={onCloseModal}
      footer={() => (
        <Footer
          step={step}
          error={data.some(item => item.__valid.value === false)}
          onSubmit={onConfirmModal}
          onCancel={onCloseModal}
          onDownload={() => props.onDownload()}
          onPrev={() => setStep(step - 1)}
          onNext={() => setStep(step + 1)}
        />
      )}
    >
      <Base.Row justify='center' className={styles.steps}>
        <Base.Col span={20}>
          <Base.Steps size='small' current={step} items={steps} />
        </Base.Col>
      </Base.Row>
      <Rule
        {...props}
        step={step}
        steps={steps}
        definitions={props.definitions}
        onSelectFile={setData}
        onNext={() => setStep(1)}
      />
      <Uploader
        definitions={props.definitions}
        step={step}
        onNext={data => {
          setStep(2);
          setData(data);
        }}
      />
      <Confirm
        {...props}
        step={step}
        steps={steps}
        data={data}
        onNext={() => setStep(3)}
      />
      <Result
        step={step}
        data={data}
        errors={props.result?.errors}
        loading={props.result?.loading}
        definitions={props.definitions}
        status={props.result?.status}
        title={props.result?.title}
        subTitle={props.result?.subTitle}
      />
    </Base.Modal>
  );
}
